"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getD3Selection = exports.barXAxisDates = exports.getStateAbbreviation = exports.allDataPoints = exports.drawTitle = exports.createDropdown = exports.secondaryColour = exports.primaryColour = exports.getColour = exports.getDefaultDrawParams = exports.getTitles = exports.valueFormat = exports.tooltipFormat = exports.isStateMetric = exports.uniqueMetricMap = exports.metricPromise = exports.parentPromise = exports.addSelectedState = exports.addSelectedStateToSingle = exports.formatSingleMetric = exports.breakLines = exports.ellipsize = exports.dateFormat = exports.dateParser = exports.insertionSort = exports.getLabelText = exports.getLabelTextMode = void 0;
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const canvas_1 = require("canvas");
const InfoTooltip_1 = __importDefault(require("../components/InfoTooltip"));
const format_1 = require("./format");
const constants_1 = require("../constants");
const colours_module_scss_1 = __importDefault(require("../styles/colours.module.scss"));
const common_module_scss_1 = __importDefault(require("../styles/common.module.scss"));
const getLabelTextMode = (data, _ref) => {
  let {
    labelTextMode
  } = _ref;
  if (labelTextMode) return labelTextMode;
  // If less than 2 items, use chart defaults
  if (data.length < 2) {
    return undefined;
  }
  const allSameState = lodash_1.default.every(data, _ref2 => {
    let {
      metric
    } = _ref2;
    return metric.geo_id === data[0].metric.geo_id;
  });
  if (allSameState) {
    return 'metrics';
  }
  const allSameMetric = lodash_1.default.every(data, _ref3 => {
    let {
      metric
    } = _ref3;
    return metric.id === data[0].metric.id;
  });
  if (allSameMetric) {
    return 'states';
  }
  return undefined;
};
exports.getLabelTextMode = getLabelTextMode;
const getLabelText = function (d, mode) {
  let ignoreLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (d.labelText !== undefined && !ignoreLabel) {
    return d.labelText;
  }
  if (mode === 'states') {
    return d.metric.geo_name;
  }
  if (mode === 'metrics') {
    return d.metric.name;
  }
  if (d.metric.geo_name && d.metric.geo_id !== 'US') {
    return d.metric.geo_name;
  }
  return d.metric.name;
};
exports.getLabelText = getLabelText;
const monthToIdx = {
  jan: 0,
  january: 0,
  feb: 1,
  february: 1,
  mar: 2,
  march: 2,
  apr: 3,
  april: 3,
  may: 4,
  jun: 5,
  june: 5,
  jul: 6,
  july: 6,
  aug: 7,
  august: 7,
  sep: 8,
  september: 8,
  oct: 9,
  october: 9,
  nov: 10,
  november: 10,
  dec: 11,
  december: 11,
  '01': 0,
  '02': 1,
  '03': 2,
  '04': 3,
  '05': 4,
  '06': 5,
  '07': 6,
  '08': 7,
  '09': 8,
  10: 9,
  11: 10,
  12: 11,
  q1: 0,
  q2: 3,
  q3: 6,
  q4: 9
};
const monthToQuarter = {
  jan: 'Q1',
  january: 'Q1',
  feb: 'Q1',
  february: 'Q1',
  mar: 'Q1',
  march: 'Q1',
  apr: 'Q2',
  april: 'Q2',
  may: 'Q2',
  jun: 'Q2',
  june: 'Q2',
  jul: 'Q3',
  july: 'Q3',
  aug: 'Q3',
  august: 'Q3',
  sep: 'Q3',
  september: 'Q3',
  oct: 'Q4',
  october: 'Q4',
  nov: 'Q4',
  november: 'Q4',
  dec: 'Q4',
  december: 'Q4'
};
const insertionSort = (nums, accessor) => {
  const clone = lodash_1.default.cloneDeep(nums);
  for (let i = 1; i < clone.length; i += 1) {
    let j = i - 1;
    const tmp = clone[i];
    while (j >= 0 && accessor(clone[j]) > accessor(tmp)) {
      clone[j + 1] = clone[j];
      j -= 1;
    }
    clone[j + 1] = tmp;
  }
  return clone;
};
exports.insertionSort = insertionSort;
const dateParserYear = date => {
  try {
    const parsedDate = new Date(Date.UTC(date, 0));
    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    return false;
  }
  return false;
};
const dateParserMonth = date => {
  try {
    let parsedDate = null;
    const [part1, part2] = date.split(/[ -/]/);
    if (monthToIdx[part1.toLowerCase()] !== undefined) {
      // Mon-YYYY
      parsedDate = new Date(Date.UTC(part2, monthToIdx[part1.toLowerCase()]));
    } else if (monthToIdx[part2.toLowerCase()] !== undefined) {
      // YYYY-MM
      parsedDate = new Date(Date.UTC(part1, monthToIdx[part2.toLowerCase()]));
    } else {
      parsedDate = new Date(Date.UTC(part2, part1));
    }
    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    return false;
  }
  return false;
};
const dateParserDay = date => {
  try {
    let parsedDate = null;
    const [part1, part2, part3] = date.split(/[ /-]/g);
    if (monthToIdx[part1.toLowerCase()] !== undefined) {
      // Mon-DD-YYYY
      const parsedDay = Number.parseInt(part2, 10); // parseInt so we catch eg '1st'
      parsedDate = new Date(Date.UTC(part3, monthToIdx[part1.toLowerCase()], parsedDay));
    } else {
      const parsedDay = Number.parseInt(part3, 10);
      if (monthToIdx[part2.toLowerCase()] !== undefined) {
        // YYYY-Mon-DD
        parsedDate = new Date(Date.UTC(part1, monthToIdx[part2.toLowerCase()], parsedDay));
      } else {
        // YYYY-MM-DD
        parsedDate = new Date(Date.UTC(part1, part2, parsedDay));
      }
    }
    if (parsedDate.toString() !== 'Invalid Date') {
      return parsedDate;
    }
  } catch (e) {
    return false;
  }
  return false;
};
const dateParser = function (date) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';
  if (type.toLowerCase() === 'items') return date;
  try {
    let parsedDate = null;
    if (type.toLowerCase() === 'months' || type.toLowerCase() === 'monthly' || type.toLowerCase() === 'quarters' || type.toLowerCase() === 'quarterly') {
      parsedDate = dateParserMonth(date);
    } else if (type.toLowerCase() === 'days' || type.toLowerCase() === 'daily' || type.toLowerCase() === 'weeks' || type.toLowerCase() === 'weekly') {
      parsedDate = dateParserDay(date);
    } else {
      parsedDate = new Date(Date.UTC(date, 0));
    }
    if (parsedDate) {
      return parsedDate;
    }
  } catch (e) {
    const yearDate = dateParserYear(date);
    if (yearDate) return yearDate;
    throw new Error(`Date ${date} is invalid`);
  }
  const yearDate = dateParserYear(date);
  if (yearDate) return yearDate;
  throw new Error(`Date ${date} is invalid`);
};
exports.dateParser = dateParser;
const dateFormat = function (date) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';
  if (type.toLowerCase() === 'items') return date;
  const [, day, month, year] = date.toUTCString().split(' ');
  if (type.toLowerCase() === 'months' || type.toLowerCase() === 'months') {
    return `${month} ${year}`;
  }
  if (type.toLowerCase() === 'quarters' || type.toLowerCase() === 'quarterly') {
    return `${monthToQuarter[month.toLowerCase()]} ${year}`;
  }
  if (type.toLowerCase() === 'days' || type.toLowerCase() === 'daily' || type.toLowerCase() === 'weeks' || type.toLowerCase() === 'weekly') {
    return `${month} ${day.replace(/^0+/, '')}, ${year}`;
  }
  return year;
};
exports.dateFormat = dateFormat;
const binaryEllipsize = (sel, text, width, min, max) => {
  const index = Math.floor((min + max) / 2);
  const splitText = text.slice(0, index);
  sel.text(`${splitText}...`);
  const textLength = sel.node().getComputedTextLength();
  if (textLength === width || max - min <= 1) {
    return;
  }
  if (textLength > width) {
    binaryEllipsize(sel, text, width, min, index);
  } else {
    binaryEllipsize(sel, text, width, index, max);
  }
};
const ellipsize = (sel, width) => {
  const textLength = sel.node().getComputedTextLength();
  const text = sel.text();
  if (textLength <= width) {
    return;
  }
  binaryEllipsize(sel, text, width, 0, text.length - 1);
};
exports.ellipsize = ellipsize;
const breakLines = function (text, width, fontStyle) {
  let maxLines = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  let canvas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (0, canvas_1.createCanvas)(500, 500);
  const lines = [];
  const lineLengths = [];
  const words = text.trim().split(' ');
  const context = canvas.getContext('2d');
  context.font = fontStyle;
  let lineStartIndex = 0;
  for (let i = 1; i <= words.length; i += 1) {
    const line = words.slice(lineStartIndex, i).join(' ');
    const measuredWidth = context.measureText(line).width;
    if (measuredWidth > width) {
      const lineEndIndex = Math.max(i - 1, lineStartIndex + 1);
      const splitLine = words.slice(lineStartIndex, lineEndIndex).join(' ');
      lines.push(splitLine);
      if (lines.length >= maxLines) {
        const lineRest = words.slice(lineStartIndex, words.length).join(' ');
        if (context.measureText(lineRest).width > Math.max(...lineLengths.map(w => w.width))) {
          if (context.measureText(`${lines[lines.length - 1]}...`).width <= width) {
            lines[lines.length - 1] = `${lines[lines.length - 1]}...`;
          } else {
            lines[lines.length - 1] = `${words.slice(lineStartIndex, lineEndIndex - 1).join(' ')}...`;
          }
        } else {
          lines[lines.length - 1] = lineRest;
        }
        return lines;
      }
      lineLengths.push(context.measureText(splitLine));
      lineStartIndex = lineEndIndex;
    }
  }
  lines.push(words.slice(lineStartIndex, words.length).join(' '));
  return lines;
};
exports.breakLines = breakLines;
const formatKey = (key, type) => {
  const stringKey = Number.isFinite(key) ? key.toString() : key;
  if (typeof stringKey !== 'string') {
    console.warn(`key "${key}" is not a string or number.`);
  }
  return {
    key: (0, exports.dateParser)(stringKey, type),
    rawKey: stringKey
  };
};
const formatSingleMetric = metric => {
  if (metric.datasets) {
    const data = metric.datasets[0];
    data.id = metric.id;
    const xType = data.x_type || data.xType || data.xtype;
    return {
      ...metric,
      xType,
      yType: data.y_type || data.yType || data.ytype,
      geo_name: data.geo_name || data.geoName,
      geo_id: data.geo_id || data.geoId,
      data: (0, lodash_1.default)(data.data).filter(_ref4 => {
        let {
          value
        } = _ref4;
        return value !== null;
      }).map(_ref5 => {
        let {
          key,
          ...rest
        } = _ref5;
        return {
          ...rest,
          ...formatKey(key, xType)
        };
      }).sortBy('key').value()
    };
  }
  return {
    ...metric,
    yType: metric.y_type || metric.yType,
    xType: metric.x_type || metric.xType,
    data: (0, lodash_1.default)(metric.data).filter(_ref6 => {
      let {
        value
      } = _ref6;
      return value !== null;
    }).map(_ref7 => {
      let {
        key,
        ...rest
      } = _ref7;
      return {
        ...rest,
        ...formatKey(key, metric.x_type || metric.xType || metric.xtype)
      };
    }).sortBy('key').value()
  };
};
exports.formatSingleMetric = formatSingleMetric;
const addSelectedStateToSingle = d => {
  if (d.metric && d.metric.datasets) {
    const selectedState = d.allStates === true && d.states && lodash_1.default.includes(lodash_1.default.map(d.states, 'fips'), d.fips);
    return {
      ...d,
      selectedState
    };
  }
  return d;
};
exports.addSelectedStateToSingle = addSelectedStateToSingle;
const addSelectedState = metric => {
  if (Array.isArray(metric)) {
    return metric.map(exports.addSelectedStateToSingle);
  }
  return (0, exports.addSelectedStateToSingle)(metric);
};
exports.addSelectedState = addSelectedState;
const parentPromise = async promise => {
  if (!promise) {
    return null;
  }
  try {
    const metric = await promise;
    return (0, exports.addSelectedState)(metric);
  } catch (e) {
    if (e.name === 'StoreError') {
      return (0, exports.addSelectedState)(e);
    }
    throw e;
  }
};
exports.parentPromise = parentPromise;
const metricPromise = async promises => {
  if (!promises) {
    return null;
  }
  if (Array.isArray(promises)) {
    const metrics = await Promise.all(promises);
    return metrics.map(exports.addSelectedState);
  }
  return (0, exports.addSelectedState)(await promises);
};
exports.metricPromise = metricPromise;
const uniqueMetricMap = d => `${d.metric.id}${d.fips ? `-${d.fips}` : ''}`;
exports.uniqueMetricMap = uniqueMetricMap;
const isStateMetric = metricObj => {
  const first = [metricObj].flat(Infinity)[0];
  const metric = first.metric || first;
  return metric.availableFilters.some(filter => filter.attribute === 12);
};
exports.isStateMetric = isStateMetric;
const getSingleFormat = data => {
  const dataAsArray = Array.isArray(data) ? data : [data];
  const types = (0, lodash_1.default)(dataAsArray).map(d => {
    var _d$metric;
    return d !== null && d !== void 0 && (_d$metric = d.metric) !== null && _d$metric !== void 0 && _d$metric.yType ? String(d.metric.yType).toLowerCase() : undefined;
  }).uniq().compact().value();
  if (types.length === 0) {
    return null;
  }
  if (types.length > 1) {
    return 'default';
  }
  return types[0];
};
const tooltipFormat = _ref8 => {
  let {
    data,
    parent,
    params
  } = _ref8;
  const valueType = params.tooltipFormat || getSingleFormat(data) || (parent ? parent.metric.yType : null) || 'default';
  return format_1.TOOLTIP_FORMATS[valueType.toLowerCase()] || format_1.TOOLTIP_FORMATS.default;
};
exports.tooltipFormat = tooltipFormat;
const valueFormat = _ref9 => {
  let {
    data,
    parent,
    params: {
      format
    }
  } = _ref9;
  const valueType = format || getSingleFormat(data) || (parent ? parent.metric.yType : null) || 'default';
  return format_1.VALUE_FORMATS[valueType.toLowerCase()] || format_1.VALUE_FORMATS.default;
};
exports.valueFormat = valueFormat;
const getTitles = _ref10 => {
  let {
    data,
    parent,
    options: {
      title: optionTitle,
      subtitle: optionSubtitle
    } = {}
  } = _ref10;
  const firstData = Array.isArray(data[0]) ? lodash_1.default.flatten(data)[0] : data[0];
  let title = '';
  let subtitle = optionSubtitle ?? '';
  if (firstData) {
    title = firstData.metric.name;
    const adjustment = firstData.metric.current_adjustment;
    if (adjustment && constants_1.ADJUSTMENT_STRINGS[adjustment]) {
      subtitle = subtitle ? `${subtitle}, ${constants_1.ADJUSTMENT_STRINGS[adjustment].toLowerCase()}` : constants_1.ADJUSTMENT_STRINGS[adjustment];
    }
  }
  if (parent && parent.metric.name !== undefined) {
    title = parent.metric.name;
  }
  if (optionTitle !== undefined) {
    title = optionTitle;
  }
  return {
    title,
    subtitle
  };
};
exports.getTitles = getTitles;
const getDefaultDrawParams = function (_ref11) {
  let {
    data,
    parent,
    options: {
      title,
      subtitle,
      margins,
      format,
      titleVerticalPosition = 'top',
      titleHorizontalAlignment = 'left',
      fontSize = 13,
      titleFontSize = parseFloat(common_module_scss_1.default.chartTitleFontSize),
      subtitleFontSize = parseFloat(common_module_scss_1.default.chartSubitleFontSize),
      fontFamily = common_module_scss_1.default.mainFontFamily,
      info,
      startYear,
      endYear,
      startDate,
      endDate,
      selectedYear,
      selectedYear2,
      selectedDropdown,
      selectedDropdown2,
      forceYear,
      forceDropdown,
      chartFootnotes,
      hideMetricFootnotes,
      chartSources
    }
  } = _ref11;
  let defaultMargins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    margins: {
      ...defaultMargins,
      ...margins
    },
    ...(0, exports.getTitles)({
      data,
      parent,
      options: {
        title,
        subtitle
      }
    }),
    format,
    titleVerticalPosition,
    titleHorizontalAlignment,
    fontSize,
    titleFontSize,
    subtitleFontSize,
    fontFamily,
    info,
    startDate: startDate || startYear,
    endDate: endDate || endYear,
    selectedYear,
    selectedYear2,
    forceYear,
    selectedDropdown,
    selectedDropdown2,
    forceDropdown,
    chartFootnotes,
    hideMetricFootnotes,
    chartSources
  };
};
exports.getDefaultDrawParams = getDefaultDrawParams;
const getColour = (d, i, params) => {
  if (d.primaryColor) {
    return d.primaryColor;
  }
  if (params.primaryColor) {
    return params.primaryColor;
  }
  const cs = Object.keys(colours_module_scss_1.default).filter(c => c.startsWith('chartcolourdefault'));
  if (d.colorIndex !== null && d.colorIndex !== undefined) {
    return colours_module_scss_1.default[`chartcolourdefault${d.colorIndex % cs.length}`];
  }
  return colours_module_scss_1.default[`chartcolourdefault${i % cs.length}`];
};
exports.getColour = getColour;
const primaryColour = (_ref12, d) => {
  let {
    primaryColor
  } = _ref12;
  if (d && d.primaryColor) {
    return d.primaryColor;
  }
  return primaryColor || colours_module_scss_1.default.chartcolourdefault0;
};
exports.primaryColour = primaryColour;
const secondaryColour = (_ref13, d) => {
  let {
    secondaryColor
  } = _ref13;
  if (d && d.secondaryColor) {
    return d.secondaryColor;
  }
  return secondaryColor || colours_module_scss_1.default.chartcolourgrey;
};
exports.secondaryColour = secondaryColour;
const createDropdown = (titleSelection, keys, className) => {
  const dropdown = titleSelection.append('div').classed(className, true).classed('drop-down-wrapper', true);
  dropdown.append('select').classed('chart-dropdown', true).selectAll('option').data(keys).enter().append('option').attr('value', d => d).text(d => d);
  return dropdown;
};
exports.createDropdown = createDropdown;
const drawTitle = function (titleSelection, subtitleSelection, _ref14, startDate, endDate) {
  let {
    params,
    years,
    keys
  } = _ref14;
  const {
    title,
    subtitle,
    selectableYears = true,
    selectableDropdowns = true,
    titleHorizontalAlignment = 'left',
    margins,
    info = {}
  } = params;
  titleSelection.style('font-size', `${params.titleFontSize}px`).style('z-index', 1) // for infotooltip overlap
  .text(`${title} `);
  subtitleSelection.style('font-size', `${params.subtitleFontSize}px`).style('z-index', 1) // for infotooltip overlap
  .text(subtitle);
  if (titleHorizontalAlignment.toLowerCase() === 'center' || titleHorizontalAlignment.toLowerCase() === 'centre') {
    titleSelection.style('text-align', 'center').style('margin-left', null);
    subtitleSelection.style('text-align', 'center').style('margin-left', null);
    if (this.isSubchart) {
      titleSelection.style('width', this.width);
    }
  } else {
    titleSelection.style('text-align', null).style('margin-left', `${margins.left}px`);
    subtitleSelection.style('text-align', null).style('margin-left', `${margins.left}px`);
  }
  let startDateColor = (0, exports.primaryColour)(params);
  let endDateColor;
  if (endDate !== undefined) {
    endDateColor = startDateColor;
    startDateColor = (0, exports.secondaryColour)(params);
  }
  if (selectableYears && selectableDropdowns) {
    let leftDropdown = titleSelection.select('.year-left');
    let rightDropdown = titleSelection.select('.year-right');
    if (startDate) {
      if (leftDropdown.empty()) {
        leftDropdown = (0, exports.createDropdown)(titleSelection, years || keys, 'year-left');
      }
      leftDropdown.style('color', startDateColor).select('select').property('value', startDate).on('change', event => {
        const el = event.currentTarget;
        if (this.setDropdownSelected) {
          this.setDropdownSelected(el.value, 0);
        }
        this.redrawContent();
      }, {
        passive: true
      });
    }
    if (endDate) {
      if (rightDropdown.empty()) {
        titleSelection.append('span').classed('chart-title-vs', true).html('&nbsp;vs&nbsp;');
        rightDropdown = (0, exports.createDropdown)(titleSelection, years || keys, 'year-right not-first');
      }
      rightDropdown.style('color', endDateColor).select('select').property('value', endDate).on('change', event => {
        const el = event.currentTarget;
        if (this.setDropdownSelected) {
          this.setDropdownSelected(el.value, 1);
        }
        this.redrawContent();
      }, {
        passive: true
      });
    }
  } else {
    const spans = [];
    if (startDate) {
      spans.push({
        text: `${title !== '' ? '&nbsp;' : ''}${startDate}`,
        color: startDateColor,
        class: 'year-left'
      });
    }
    if (endDate) {
      spans.push({
        text: '&nbsp;vs',
        color: null,
        class: 'chart-title-vs'
      });
      spans.push({
        text: `&nbsp;${endDate}`,
        color: endDateColor,
        class: 'year-right'
      });
    }
    titleSelection.selectAll('span').data(spans).join('span').attr('class', d => d.class).style('color', d => d.color).html(d => d.text);
  }
  if (info.position === 'title') {
    new InfoTooltip_1.default(titleSelection, d3.select(titleSelection.node().parentNode), info.position, {}, info.isFootnote).onHover(info);
  }
};
exports.drawTitle = drawTitle;
const allDataPoints = function (data, startDate, endDate) {
  let xType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'years';
  let dataSelector = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : exports.uniqueMetricMap;
  // remove null values and add in dataset name for both single and array data rows
  const noNulls = data.map(d => (Array.isArray(d) ? d.flatMap(v => v.metric.data) : d.metric.data).map(v => {
    const thisD = Array.isArray(d) ? d[0] : d;
    return {
      ...v,
      dataset: dataSelector(thisD),
      metric: thisD
    };
  }).filter(v => v.value !== null));
  if (xType.toLowerCase() !== 'items') {
    const start = startDate ? (0, exports.dateParser)(startDate, xType) : new Date(0);
    const end = endDate ? (0, exports.dateParser)(endDate, xType) : new Date();
    const filtered = noNulls.map(d => d.filter(v => {
      if (startDate !== undefined && startDate !== null && !Number.isNaN(start.getTime()) && v.key < start) {
        return false;
      }
      if (endDate !== undefined && endDate !== null && !Number.isNaN(end.getTime()) && v.key > end) {
        return false;
      }
      return true;
    }).map((v, i) => ({
      ...v,
      fromEnd: d.length - i - 1
    })));
    const flattened = lodash_1.default.flatten(filtered);
    if (flattened.length > 0) {
      return flattened;
    }
  }
  return (0, lodash_1.default)(noNulls).map(d => d.map((v, i) => ({
    ...v,
    fromEnd: v.length - i - 1
  }))).flatten().value();
};
exports.allDataPoints = allDataPoints;
const getStateAbbreviation = label => {
  const stateKey = Object.keys(constants_1.STATE_ABBREVS).find(k => k.toLowerCase() === label.toLowerCase());
  if (stateKey) {
    return constants_1.STATE_ABBREVS[stateKey];
  }
  return label;
};
exports.getStateAbbreviation = getStateAbbreviation;
const divideDates = (dates, maxTicks, startIndex) => {
  let outDates = lodash_1.default.clone(dates);
  // divide into quarters, then years, 5 years, 10 years, 20 years
  const axisDivides = [3, 4, 5, 2, 2].slice(startIndex || 0);
  axisDivides.forEach(divide => {
    if (outDates.length > maxTicks) {
      outDates = outDates.filter((date, i) => i % divide === 0);
    }
  });
  return outDates;
};
const barXAxisDates = function (dates) {
  let xType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'years';
  let maxTicks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  if (dates.length < maxTicks) return dates;
  const lower = xType.toLowerCase();
  if (lower === 'months' || lower === 'monthly') {
    return divideDates(dates, maxTicks);
  }
  if (lower === 'quarters' || lower === 'quarterly') {
    return divideDates(dates, maxTicks, 1);
  }
  if (lower === 'days' || lower === 'daily') {
    let outDates = lodash_1.default.clone(dates);
    // divide into weeks
    outDates = outDates.filter((date, i) => i % 7 === 0);
    if (outDates.length <= maxTicks) return outDates;
    outDates = d3.utcMonth.range(d3.utcMonth.floor(lodash_1.default.min(dates)), d3.utcMonth.floor(lodash_1.default.max(dates)));
    outDates.push(d3.utcMonth.floor(lodash_1.default.max(dates)));
    if (outDates[0].getTime() !== dates[0].getTime()) outDates = outDates.slice(1);
    if (outDates.length <= maxTicks) return outDates;
    return divideDates(outDates, maxTicks);
  }
  return divideDates(dates, maxTicks, 2);
};
exports.barXAxisDates = barXAxisDates;
const getD3Selection = element => {
  if (element instanceof Element) {
    return d3.select(element);
  }
  if (element instanceof d3.selection) {
    return element;
  }
  return null;
};
exports.getD3Selection = getD3Selection;